module.exports = __webpack_public_path__ + "static/media/CodeXBody.6974a41c.glb";